import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@material-ui/core/TablePagination'; 
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import pageimg from './images/attendance.png';
import ReactToPrint from 'react-to-print';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,DatePicker, 
  KeyboardDatePicker,
  DateTimePicker
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { addDays } from "date-fns";
import Moment from 'react-moment';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
const headCells = [

{ id: '', numeric: false, label: 'Sl No.' },
 { id: 'feedate', numeric: false, label: 'Date' },
 { id: 'fp_receiptnumber', numeric: false, label: 'Reciept No.' },
  { id: 'sr_studentcode', numeric: false, label: 'Student Code' },
  { id: 'sr_studentname', numeric: false, label: 'Student Name' },
 { id: 'tc_title', numeric: false, label: 'Class' },
  { id: 'bc_title', numeric: false, label: 'Batch' },
  { id: 'fp_amount', numeric: false, label: 'Amount' },
  { id: 'paymentmode', numeric: false, label: 'Payment Mode' },

  
  ]
function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
		const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
		const createSortHandler = property => event => {
		onRequestSort(event, property);
		};

	  return (
		<TableHead>
		  <TableRow>
			
			{headCells.map(headCell => (
			  <TableCell
				key={headCell.id}
				align={headCell.numeric ? 'right' : 'left'}
				padding={headCell.disablePadding ? 'none' : 'default'}
				sortDirection={orderBy === headCell.id ? order : false}
			  >
				<TableSortLabel
				  active={orderBy === headCell.id}
				  direction={orderBy === headCell.id ? order : 'asc'}
				  onClick={createSortHandler(headCell.id)}
				>
				  {headCell.label}
				  {orderBy === headCell.id ? (
					<span className={useStyles.visuallyHidden}>
					  {order === 'desc' ? ' ' : ' '}
					</span>
				  ) : null}
				</TableSortLabel>
			  </TableCell>
			))}
		  </TableRow>
		</TableHead>
	  );
}


EnhancedTableHead.propTypes = {
	  classes: PropTypes.object.isRequired,
	 
	  onRequestSort: PropTypes.func.isRequired,
	 
	  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
	  orderBy: PropTypes.string.isRequired,
	  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class feepayment extends Component {
	
    constructor(props) {
    super(props);
   var date = addDays(moment().toDate(),-30);
		var month="",  month1="",date1="";
		if((date.getMonth() + 1)<10)
		{
			month="0"+ (date.getMonth() + 1)		 
		}else{month=(date.getMonth() + 1)}
		if((date.getDate() )<10)
		{
			date1="0"+ (date.getDate())		 
		}else{date1=(date.getDate() )}
		
		var strtodate = addDays(moment().toDate(),0);
   var strmonth="",  month1="",strdate1="";
  if((strtodate.getMonth() + 1)<10)
	 {
		strmonth="0"+ (strtodate.getMonth() + 1)		 
	 }else{strmonth=(strtodate.getMonth() + 1)}
	  if((strtodate.getDate() )<10)
	 {
		strdate1="0"+ (strtodate.getDate())		 
	 }else{strdate1=(strtodate.getDate() )}
      this.state = {redirect: false,
      feepaymentdata:[],page: 0 ,prevpage:0,totaldata:0,rowsPerPage:100,rowsPaging:[],Classarr:[],classid:'',classlabel:'Select Class',Yeararr:[],yearid:'',yearlabel:'Select Year',Brancharr:[],branchid:'',branchlabel:'',
	 
	  order:'desc' ,orderBy:'',studentname:'',searchcustomer:'',date: addDays(moment().toDate(),0),Batcharr:[],batchid:'',batchlabel:'Select Batch',
	fdate:addDays(moment().toDate(),-30),tdate:addDays(moment().toDate(),0),fdate1:date.getFullYear() + '-' + month + '-' +date1,tdate1:strtodate.getFullYear() + '-' + strmonth + '-' +strdate1,paymenttype:'',
	          
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => {this.componentDidMount();  }
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,feepaymentdata:[]
    });
	
//this.componentDidMount();  
}
		componentWillMount() { 
localStorage.setItem("pageactive",10)
}	
componentDidUpdate() {
	
  if(this.state.prevpage !== this.state.page) {
    this.setState({   prevpage: this.state.page});
  this.apicall(this.state.page, localStorage.getItem("page"));  
  }
}




	componentDidMount() {
	


	 
		
	
	
	document.title = "MM Coching Center - Feepayment Details";
	
	if(localStorage.getItem("MMCuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
		  else {
			  
			  if(localStorage.getItem("MMCrole")!=="1")
	 
		  { this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
		  }
	
	
	this.YearBind();
	
 
} 


YearBind()
{
	axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=3')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Yeararr:resp.data,yearid:	resp.data[0]["tc_id"]
							}) 
			}
		this.ClassBind()
	   }) .then(data => {
        let yearFromApi = this.state.Yeararr.map(row => {
                          
          return {value: row.tc_id, display:row.tc_title}
        });
      
		
        this.setState({
          Yeararr: [{value: '0', display: 'Select Year'}].concat(yearFromApi)
        });
      })

}
ClassBind()
{
	axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=2')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Classarr:resp.data	
							}) 
			}
	this.BranchBind();
	   }) .then(data => {
        let classFromApi = this.state.Classarr.map(row => {
                          
          return {value: row.tc_id, display:row.tc_title}
        });
      
		
        this.setState({
          Classarr: [{value: '0', display: 'Select Class'}].concat(classFromApi)
        });
      })

}

BatchBind()
{let strbranch=localStorage.getItem("MMCbranchid")
	
	if(localStorage.getItem("MMCbranchid")==="1")
	{
		strbranch=this.state.branchid;
	}
	axios.get(Serverurl+'ajaxbatch.php?action=list&bc_class_id='+this.state.classid+'&bc_br_id='+strbranch)
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Batcharr:resp.data	
							}) 
			}else{
				
				this.setState({
						Batcharr:[]	
							}) 
			}

	   }).then(data => {
        let batchFromApi = this.state.Batcharr.map(row => {
                          
          return {value: row.bc_id, display:row.bc_title}
        });
      
		
        this.setState({
          Batcharr: [{value: '0', display: 'Select Batch'}].concat(batchFromApi)
        });
      })

}
BranchBind()
{
	axios.get(Serverurl+'ajaxbranch.php?action=getall')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Brancharr:resp.data	
							}) 
			}
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
	   }) .then(data => {
        let branchFromApi = this.state.Brancharr.map(row => {
                          
          return {value: row.br_id, display:row.br_title}
        });
      
		
        this.setState({
          Brancharr: [{value: '0', display: 'Select Branch'}].concat(branchFromApi)
        });
      })

}
handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
	   this.setState({[nam]: val}, () => {
if( this.state.classid!="0")
	   {
		this.BatchBind();      
 
	   }
}); 
 
 
}

apicall(page,rowsPerPage){
	 let strpay="2",strbranch=localStorage.getItem("MMCbranchid");
	
	  if(localStorage.getItem("MMCrole")==="1")
	 
		  { strpay="1";
			  strbranch=this.state.branchid;
		  }
	 axios.get(Serverurl+'ajaxfeepayments.php?action=listreport&fp_isfirstpay='+strpay+'&batchid='+this.state.batchid+'&branchid='+strbranch+'&yearid='+this.state.yearid+'&classid='+this.state.classid+'&fp_sa_id='+this.state.studentname+'&fromdate='+this.state.fdate1+'&todate='+this.state.tdate1+'&fp_paymentmode='+this.state.paymenttype+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  feepaymentdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
			let copy=[50, 100, 150, 200, 250];
			
	  
	  this.setState({rowsPaging:copy});
	 
     }
	 else{
		   this.setState({feepaymentdata:[],totaldata:0});
	 }
 
    });
}

 handfrChanges = (date) => {
	 
	 var month="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
     this.setState({ fdate:date,
fdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }  
    
handtoChanges = (date) => {
	
	  var month="";
	 
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({ tdate:date,
tdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }





handleChangePage = (event, newPage) => {  
   
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  };  
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)

    setTimeout(() =>  this.componentDidUpdate() ,500);
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
 
  <React.Fragment>
   
<div className="containermain">
<div className="boxheading">
				  <div className="contntpad">
<h2><img src={pageimg}/>Other Payments Report</h2>
</div></div>
<div className="searchmaster">


  
  <ul>
    <li>
<p>From Date. <span className="validationtxt"></span></p>
 <p>
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justify="space-around">
	 
      <DatePicker fullWidth
        value={this.state.fdate || addDays(moment().toDate(),1)}
        onChange={this.handfrChanges}
		maxDate={addDays(moment().toDate(),0)}
            format="dd/MM/yyyy"
        autoOk name="fdate"
        ampm={false} inputVariant="outlined"
      />
	   </Grid>
    </MuiPickersUtilsProvider>
		</p></li>
<li>
	<p>To Date. <span className="validationtxt"></span></p>
	  <p>
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justify="space-around">
      <DatePicker fullWidth
        value={this.state.tdate || addDays(moment().toDate(),1)}
        onChange={this.handtoChanges}
		maxDate={addDays(moment().toDate(),0)}
            format="dd/MM/yyyy"
        autoOk name="tdate"
        ampm={false} inputVariant="outlined"
      />
	   </Grid>
    </MuiPickersUtilsProvider>
	
		</p></li>
		<li><p><span className="validation">*</span>Year</p>
	  <p>
	  <FormControl  fullWidth size="small" >
        
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.yearlabel, value: this.state.yearid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.yearid}
		  name="yearid"
		
		
        >
		{this.state.Yeararr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	  </li>
	  {localStorage.getItem("MMCrole")==="1" && (
	  <li><p><span className="validation">*</span>Branch</p>
	  <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.branchlabel, value: this.state.branchid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.branchid}
		  name="branchid"
		
		
        >
		{this.state.Brancharr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	  </li>)}
		 <li><p><span className="validation">*</span>Class</p>
	  <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.classlabel, value: this.state.classid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.classid}
		  name="classid"
		
		
        >
		{this.state.Classarr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	  </li>
	    <li><p><span className="validation">*</span>Batch</p>
	  <p>
	  <FormControl  fullWidth size="small" >
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.batchlabel, value: this.state.batchid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.batchid}
		  name="batchid"
		
		
        >
		{this.state.Batcharr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	  </li>
 <li><p>Student Name</p>
 <p ><TextField
            variant="outlined"
            margin="normal"
			size="small"
            fullWidth value={this.state.studentname}
           inputProps={{tabIndex: "2",maxLength:150}}
			placeholder="Student Name"
            name="studentname" onChange={this.myChangeHandler}
		
          /></p></li>
		
	
		
	
	<li><p>Payment Mode</p><p>
		<FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		size="small"
		native
		value={this.state.paymenttype}
		onChange={this.myChangeHandler}
		name='paymenttype'
		id='paymenttype'
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select Payment Mode</option>
		<option value={1}>UPI</option>
		<option value={2}>Net Banking</option>
		<option value={3}>Cash</option>
		<option value={4}>Cheque</option>
		</Select>
		</FormControl>
	</p>
	</li>
	
	<li>
	
	<p>
	<Button variant="contained" onClick={this.handleClickSearch} className="frmsecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>&nbsp;&nbsp;
	  <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="exportbtn"
                    table="purreport"
                    filename="FEE Payment Report"
                    sheet="Fee Payment Report"
                    buttonText="Export"/>&nbsp;&nbsp;<ReactToPrint 
            trigger={() => <p id="print-button" className="exportbtns">Print </p>}
			content={() =>  this.componentRef} />
	  
	  </p>
	</li>
	</ul>
		
	
</div>	 <div ref={el => (this.componentRef = el)} >
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table" id="purreport">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.feepaymentdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.feepaymentdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
	let i= parseFloat(((this.state.page)+1)-1)*parseFloat(this.state.rowsPerPage)+(parseFloat(index)+1);
        		
           return (
 <React.Fragment>
 <TableRow key={index} >
  <TableCell>{i}</TableCell>
<TableCell>{item.feedate}</TableCell>
<TableCell>{item.fp_receiptnumber}</TableCell>
<TableCell>{item.sr_studentcode}</TableCell>
<TableCell>{item.sr_studentname}</TableCell>

<TableCell>{item.tc_title}</TableCell>
<TableCell>{item.bc_title}</TableCell>
<TableCell>Rs.{item.fp_amount}</TableCell>
<TableCell>{item.paymentmode}</TableCell>

</TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colSpan="5">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[100,  200, 300, 400, 500]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>  </div>
  </div>	  

 </React.Fragment> 

 
 
  );
}
}

